// import React from 'react';
// import Icon from '../../../components/AppIcon';

// const TradingModeSelection = ({ selectedMode, onModeSelect, selectedMarket, selectedMainStrategy }) => {
//   const tradingModes = [
//     {
//       id: 'long-only',
//       title: 'Long Only',
//       description: 'Buy low, sell high - profit from price increases',
//       explanation: 'Bot will only open buy positions when conditions are met and close them for profit.',
//       pros: ['Simple strategy', 'Lower risk', 'Good for bull markets'],
//       cons: ['No profit in bear markets', 'Limited opportunities'],
//       icon: 'TrendingUp',
//       color: 'success',
//       available: selectedMainStrategy !== 'TP_SL'
//     },
//     {
//       id: 'short-only',
//       title: 'Short Only',
//       description: 'Sell high, buy low - profit from price decreases',
//       explanation: 'Bot will only open short positions to profit from falling prices.',
//       pros: ['Profit in bear markets', 'Hedge against losses'],
//       cons: ['Higher risk', 'Requires margin'],
//       icon: 'TrendingDown',
//       color: 'error',
//       available: selectedMainStrategy !== 'TP_SL'
//     },
//     {
//       id: 'hedge',
//       title: 'Long & Short (Hedge)',
//       description: 'Trade both directions based on market conditions',
//       explanation: 'Bot can open both long and short positions to maximize opportunities in any market.',
//       pros: ['Maximum opportunities', 'Market neutral', 'Advanced strategies'],
//       cons: ['Complex management', 'Higher fees', 'Requires experience'],
//       icon: 'ArrowUpDown',
//       color: 'primary',
//       available: selectedMainStrategy == 'TP_SL'
//     }
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="text-center">
//         <h3 className="text-2xl font-bold text-foreground mb-2">Select Trading Mode</h3>
//         <p className="text-muted-foreground">
//           Choose how your bot will trade in the {selectedMarket} market
//         </p>
//       </div>

//       <div className="space-y-4">
//         {tradingModes.map((mode) => {
//           const isAvailable = mode.available;
//           const isSelected = selectedMode === mode.id;

//           return (
//             <div
//               key={mode.id}
//               className={`
//                 relative p-6 border-2 rounded-xl trading-transition
//                 ${!isAvailable
//                   ? 'border-border bg-muted/20 opacity-50 cursor-not-allowed'
//                   : isSelected
//                   ? 'border-primary bg-primary/5 cursor-pointer'
//                   : 'border-border hover:border-primary/50 bg-card cursor-pointer'
//                 }
//               `}
//               onClick={() => isAvailable && onModeSelect(mode.id)}
//             >
//               {!isAvailable && (
//                 <div className="absolute top-4 right-4 bg-muted text-muted-foreground px-2 py-1 rounded text-xs">
//                   {selectedMarket === 'spot' ? 'Futures Only' : 'Not available with TP/SL'}
//                 </div>
//               )}

//               <div className="flex items-start space-x-4">
//                 <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
//                   !isAvailable
//                     ? 'bg-muted'
//                     : isSelected
//                     ? `bg-${mode.color} text-${mode.color}-foreground`
//                     : 'bg-muted'
//                 }`}>
//                   <Icon name={mode.icon} size={24} />
//                 </div>

//                 <div className="flex-1">
//                   <div className="flex items-center justify-between mb-2">
//                     <h4 className="text-lg font-semibold text-foreground">{mode.title}</h4>
//                     {isAvailable && (
//                       <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
//                         isSelected ? 'border-primary bg-primary' : 'border-border'
//                       }`}>
//                         {isSelected && <div className="w-2 h-2 bg-primary-foreground rounded-full" />}
//                       </div>
//                     )}
//                   </div>

//                   <p className="text-muted-foreground text-sm mb-3">{mode.description}</p>
//                   <p className="text-foreground text-sm mb-4">{mode.explanation}</p>

//                   <div className="grid md:grid-cols-2 gap-4">
//                     <div>
//                       <h6 className="text-sm font-medium text-success mb-2 flex items-center">
//                         <Icon name="Plus" size={14} className="mr-1" />
//                         Advantages
//                       </h6>
//                       <ul className="space-y-1">
//                         {mode.pros.map((pro, i) => (
//                           <li key={i} className="text-xs text-muted-foreground flex items-center">
//                             <Icon name="Check" size={12} className="mr-2 text-success" />
//                             {pro}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                     <div>
//                       <h6 className="text-sm font-medium text-error mb-2 flex items-center">
//                         <Icon name="Minus" size={14} className="mr-1" />
//                         Considerations
//                       </h6>
//                       <ul className="space-y-1">
//                         {mode.cons.map((con, i) => (
//                           <li key={i} className="text-xs text-muted-foreground flex items-center">
//                             <Icon name="AlertTriangle" size={12} className="mr-2 text-warning" />
//                             {con}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {selectedMarket === 'spot' && (
//         <div className="bg-muted/50 border border-border rounded-lg p-4">
//           <div className="flex items-start space-x-3">
//             <Icon name="Info" size={20} className="text-primary mt-0.5" />
//             <div>
//               <h5 className="font-medium text-foreground mb-1">Spot Trading Limitation</h5>
//               <p className="text-sm text-muted-foreground">
//                 Short selling and hedging are not available in spot trading. 
//                 Switch to futures to unlock these features.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TradingModeSelection;


import React from 'react';
import Icon from '../../../components/AppIcon';

const TradingModeSelection = ({ selectedMode, onModeSelect, selectedMarket, selectedMainStrategy }) => {
  const tradingModes = [
    {
      id: 'long-only',
      title: 'Long Only',
      description: 'Buy low, sell high - profit from price increases',
      explanation: 'Bot will only open buy positions when conditions are met and close them for profit.',
      pros: ['Simple strategy', 'Lower risk', 'Good for bull markets'],
      cons: ['No profit in bear markets', 'Limited opportunities'],
      icon: 'TrendingUp',
      color: 'success',
      available: selectedMainStrategy !== 'TP_SL'
    },
    {
      id: 'short-only',
      title: 'Short Only',
      description: 'Sell high, buy low - profit from price decreases',
      explanation: 'Bot will only open short positions to profit from falling prices.',
      pros: ['Profit in bear markets', 'Hedge against losses'],
      cons: ['Higher risk', 'Requires margin'],
      icon: 'TrendingDown',
      color: 'error',
      available: selectedMainStrategy !== 'TP_SL'
    },
    {
      id: 'hedge',
      title: 'Long & Short (Hedge)',
      description: 'Trade both directions based on market conditions',
      explanation: 'Bot can open both long and short positions to maximize opportunities in any market.',
      pros: ['Maximum opportunities', 'Market neutral', 'Advanced strategies'],
      cons: ['Complex management', 'Higher fees', 'Requires experience'],
      icon: 'ArrowUpDown',
      color: 'primary',
      available: selectedMainStrategy === 'TP_SL'
    }
  ];

  // Filter only available modes
  const availableModes = tradingModes.filter(mode => mode.available);

  // Optional: Show a message if no modes are available (shouldn't happen, but safe)
  if (availableModes.length === 0) {
    return (
      <div className="text-center py-10">
        <p className="text-muted-foreground">No trading modes available for current configuration.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-foreground mb-2">Select Trading Mode</h3>
        <p className="text-muted-foreground">
          Choose how your bot will trade in the {selectedMarket} market
        </p>
      </div>

      <div className="space-y-4">
        {availableModes.map((mode) => {
          const isSelected = selectedMode === mode.id;

          return (
            <div
              key={mode.id}
              className={`
                relative p-6 border-2 rounded-xl transition-all cursor-pointer
                ${isSelected
                  ? 'border-primary bg-primary/5 shadow-lg'
                  : 'border-border hover:border-primary/50 bg-card'
                }
              `}
              onClick={() => onModeSelect(mode.id)}
            >
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  isSelected
                    ? `bg-${mode.color} text-${mode.color}-foreground`
                    : 'bg-muted'
                }`}>
                  <Icon name={mode.icon} size={24} />
                </div>

                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-lg font-semibold text-foreground">{mode.title}</h4>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                      isSelected ? 'border-primary bg-primary' : 'border-border'
                    }`}>
                      {isSelected && <div className="w-2 h-2 bg-primary-foreground rounded-full" />}
                    </div>
                  </div>

                  <p className="text-muted-foreground text-sm mb-3">{mode.description}</p>
                  <p className="text-foreground text-sm mb-4">{mode.explanation}</p>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <h6 className="text-sm font-medium text-success mb-2 flex items-center">
                        <Icon name="Plus" size={14} className="mr-1" />
                        Advantages
                      </h6>
                      <ul className="space-y-1">
                        {mode.pros.map((pro, i) => (
                          <li key={i} className="text-xs text-muted-foreground flex items-center">
                            <Icon name="Check" size={12} className="mr-2 text-success" />
                            {pro}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h6 className="text-sm font-medium text-error mb-2 flex items-center">
                        <Icon name="Minus" size={14} className="mr-1" />
                        Considerations
                      </h6>
                      <ul className="space-y-1">
                        {mode.cons.map((con, i) => (
                          <li key={i} className="text-xs text-muted-foreground flex items-center">
                            <Icon name="AlertTriangle" size={12} className="mr-2 text-warning" />
                            {con}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Spot market info box - only show if spot and hedge/short would normally be hidden */}
      {selectedMarket === 'spot' && selectedMainStrategy !== 'TP_SL' && (
        <div className="bg-muted/50 border border-border rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} className="text-primary mt-0.5" />
            <div>
              <h5 className="font-medium text-foreground mb-1">Spot Trading Limitation</h5>
              <p className="text-sm text-muted-foreground">
                Short selling and hedging are only available in futures trading. 
                Switch to futures to access all trading modes.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TradingModeSelection;